import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useProfileStore } from '../store/useProfileStore';
import { useToast } from '@/components/ui/use-toast';

const schema = z.object({
  currentPassword: z.string(),
  password: z.string(),
  passwordConfirmation: z.string(),
});

type FormData = z.infer<typeof schema>;

export function usePasswordForm() {
  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit, control } = useForm<FormData>({
    resolver: zodResolver(schema),
  });
  const { onUpdatePassword, page } = useProfileStore();
  const { toast } = useToast();

  const onSubmit = async (data: FormData) => {
    setIsLoading(true);
    const { error } = await onUpdatePassword(data);
    if (error) {
      toast({
        title: 'Error updating password',
        description: error,
        variant: 'destructive',
      });
      setIsLoading(false);
      return;
    }
    toast({
      title: 'Password updated',
      description: 'Your password has been updated successfully',
    });

    setIsLoading(false);
  };

  return {
    isLoading,
    control,
    page,
    handleSubmit: handleSubmit(onSubmit),
  };
}
